import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../../Components';
import AutoPigModel from '../../../../Components/AutoPig/autoPigModel';
import BasicData from '../../../../Components/AutoPig/basicData';
import { frames } from '../../../../Styles'

export default function Settings() {
  const {t} = useTranslation()

  // Get System Name for Header
  // const { systemName } = useMemo(() => {
  //   const systemData = SystemData.find((system) => system.systemId === 1);
  //   return {
  //     systemName: systemData?.systemName || "",
  //   };
  // }, []);

  return (
    <frames.Page_inner>
        <PageHeader topHeader={"systemName"} subHeader={"Settings"}/>
      
      <frames._page_inner_content_scroll>

      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}